import React from 'react';
import { isLive } from '../../Utils/Utilities';

export default function SahiLongFooter({
  description = "The B2B community & growth network built for PCB & electronics businesses across India.",
  tagline = "Made for India's electronics manufacturing belt",
  year = 2026
}) {
  return (
    <footer className="bg-white border-t border-gray-200/80 pt-10 sm:pt-14 pb-8 sm:pb-12 text-gray-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Top Section: Logo & Description (Left) | Company & Address (Right) */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-12">
          
          {/* Left Column */}
          <div className="max-w-md">
            <a href="/" className="inline-block mb-3.5">
              <img
                src={isLive() ? "/Web/assets/Images/SahiLogo.png" : "/assets/Images/SahiLogo.png"}
                alt="SahiClub"
                className="h-7 sm:h-8 w-auto object-contain"
              />
            </a>
            {description && (
              <p className="text-xs sm:text-sm text-gray-500 leading-relaxed max-w-sm">
                {description}
              </p>
            )}
          </div>

          {/* Right Column: Company & Address */}
          <div className="text-left md:text-right text-xs text-gray-500 space-y-1">
            <div className="font-bold text-gray-900 text-xs sm:text-sm mb-1.5">
              © {year} Biziverse Pvt. Ltd.
            </div>
            <div>Peach Campus</div>
            <div>A/44 GIDC Electronics Estate,</div>
            <div>Gandhinagar, Gujarat 382016, India</div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200/70 my-6 sm:my-8" />

        {/* Bottom Section: Dynamic Tagline (Left) | Legal Links (Right) */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <div>
            {tagline}
          </div>
          <div className="flex items-center gap-6">
            <a
              href="https://sahicrm.com/Web/policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-sahi-green transition-colors text-gray-600 hover:underline"
            >
              Privacy Policy
            </a>
            <a
              href="https://sahicrm.com/Web/STerms.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-sahi-green transition-colors text-gray-600 hover:underline"
            >
              Sales Terms
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
